module.exports = __webpack_public_path__ + "static/media/bar_under_french.95af835f.png";